import * as React from 'react';
import { useSearch } from '../hooks';

interface PaginationProps {
  itemsPerPage: number;
  onPaginate: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
  itemsPerPage,
  onPaginate
}) => {
  // Get locale from html element
  const html = document.querySelector('html');
  const locale = html?.getAttribute('lang') || 'en';

  const {
    state: { page, resultsTotal },
    updatePage
  } = useSearch();

  const totalPages = Math.ceil(resultsTotal / itemsPerPage);

  const goToPage = (page: number) => {
    onPaginate();
    updatePage(page);
  };

  if (totalPages < 2) {
    return null;
  }

  const translate = (key: number) => {
    return key.toLocaleString(locale);
  };

  const displayPages = () => {
    const pages = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i > 1 && i < totalPages) {
        const offsetLeft = page === 1 ? 2 : 1;
        const offsetRight = page === totalPages ? 2 : 1;

        if (i === page + offsetLeft + 1 || i === page - offsetRight - 1) {
          pages.push(
            <span className="pagination__separator" key={`separator-${i}`}>
              ...
            </span>
          );
        }

        if (i > page + offsetLeft || i < page - offsetRight) {
          continue;
        }
      }

      pages.push(
        <button
          key={`page-${i}`}
          className="pagination__button"
          aria-label={`Goto Page ${i}`}
          aria-current={i === page ? 'true' : undefined}
          onClick={() => goToPage(i)}
        >
          {translate(i)}
        </button>
      );
    }

    return pages;
  };

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        className="pagination__prev"
        aria-label="Goto Previous Page"
        disabled={page === 1}
        onClick={() => goToPage(page - 1)}
      >
        <span></span>
      </button>
      {displayPages()}
      <button
        className="pagination__next"
        aria-label="Goto Next Page"
        disabled={page === totalPages}
        onClick={() => goToPage(page + 1)}
      >
        <span></span>
      </button>
    </nav>
  );
};

export default Pagination;
